<template>
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.52039 8.33332L8.18706 13L6.99955 14.1667L0.332886 7.49998L6.99955 0.833313L8.18706 1.99998L3.52039 6.66665H13.6662V8.33332H3.52039Z" fill="currentcolor"/>
    </svg>

</template>